import { FC } from 'react'

import { NodeProps, Position } from '@xyflow/react'

import {
  EditorNodeTemplate,
  NodeHandle
} from 'Automations/nodeDefinitions/components'

export const EndEditorNode: FC<NodeProps> = ({ id, selected }) => {
  return (
    <EditorNodeTemplate nodeId={id} selected={selected}>
      <NodeHandle
        nodeId={id}
        type="target"
        position={Position.Left}
        selected={selected}
      />
    </EditorNodeTemplate>
  )
}
